import { IDeviceService } from "../../service/device/DeviceService";
import { IUserCredential } from "../../model/user/UserCredential";

export default class RemoveDeviceInteractor {
  private deviceService: IDeviceService;

  constructor({ deviceService }: { deviceService: IDeviceService }) {
    this.deviceService = deviceService;
  }

  async execute(deviceId: number, userCredential: IUserCredential) {
    return this.deviceService.removeDevice(deviceId, userCredential);
  }
}
